<template>
    <div class="wrap">
        <div class="login_box">
            <p class="login_title">登录</p>
            <el-form class="login_form" @keyup.enter.native="handleLogin" ref="form" :model="form">
                <el-form-item class="qrcode" v-if="isVerification">
                    <el-select class="widthInherit qrcode_input" v-model="projectVal" placeholder="请选择" @change="projectChange">
                        <el-option v-for="item in projectOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                    <div class="verify-box" v-if="qrcodeSrc">
                        <el-button type="primary" @click="update">更新域名</el-button>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.username" size="medium" placeholder="请输入用户名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.password" size="medium" placeholder="请输入密码" type="password"></el-input>
                </el-form-item>
                <el-form-item class="qrcode" v-if="isVerification">
                    <el-input class="qrcode_input" v-model="form.code" placeholder="请输入验证码"></el-input>
                    <div v-if="qrcodeSrc" class="verify-box" @click="refreshCode">
                        <img :src="'data:image/jpeg;base64,' + qrcodeSrc.img" alt="" />
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-button class="submit_btn" size="medium" :disabled="isDisabled" @click="handleLogin">登 录 </el-button>
                </el-form-item>
            </el-form>
            <!-- <span class="resetPassBtn" @click="resetPasswordDialogOpen">重置密码</span> -->
            <!-- <span class="resetPassBtn" @click="update">更新</span> -->
        </div>
        <div class="version">Copyright @{{ new Date().getFullYear() }}</div>
        <div>
            <el-dialog :visible.sync="dialogVisible" title="重置密码" width="680px" append-to-body>
                <el-form ref="resetPasswordForm" :model="resetPasswordForm" :rules="resetPasswordRules" label-width="120px">
                    <el-form-item label="用户名" prop="username">
                        <el-input v-model="resetPasswordForm.username" placeholder="请输入用户名"></el-input>
                    </el-form-item>
                    <el-form-item label="图片验证码" prop="code">
                        <el-row>
                            <el-col :span="16">
                                <el-input v-model="resetPasswordForm.code" placeholder="请输入图片验证码"></el-input>
                            </el-col>
                            <el-col :span="8">
                                <div v-if="qrcodeSrc" class="verify-box" @click="refreshRestCaptcha">
                                    <img :src="'data:image/jpeg;base64,' + resetPasswordForm.captcha.img" alt="" />
                                </div>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="短信验证码" prop="mobileCode">
                        <el-row>
                            <el-col :span="16">
                                <el-input v-model="resetPasswordForm.mobileCode" placeholder="请输入短信验证码"></el-input>
                            </el-col>
                            <el-col :span="8">
                                <el-button :disabled="countdown > 0" @click="getSmsCode">
                                    {{ countdown > 0 ? `${countdown}秒后重试` : '获取短信验证码' }}
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="新密码" prop="password">
                        <el-input type="password" v-model="resetPasswordForm.password" placeholder="请输入新密码"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="confirmPassword">
                        <el-input type="password" v-model="resetPasswordForm.confirmPassword" placeholder="请输入确认密码"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer">
                    <el-button @click="cancelResetPwd()">取消</el-button>
                    <el-button type="primary" @click="resetPassword">确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import { setTimeToken } from '@/utils/auth.js';

export default {
    name: 'loginHl',
    components: {},
    data() {
        return {
            codeTime: 0, //验证码时间
            redirect: '',
            isVerification: true,
            isDisabled: false,
            identifyCode: '',
            identifyCodes: [1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
            passwordShow: false, //密码是否显示
            codeActive: false, //发送验证码按钮颜色
            isClickCode: false, //是否点击过发送验证码
            qrcodeSrc: '',
            form: {
                //   code:'202112',
                username: '', //用户名
                password: '' //密码
            },
            dialogVisible: false,
            countdown: 0,
            timer: null, // 定时器变量
            resetPasswordForm: {
                username: '',
                code: '',
                mobileCode: '',
                password: '',
                confirmPassword: '',
                uuid: '',
                captcha: ''
            },
            resetPasswordRules: {
                username: [
                    { required: true, message: '用户名不能为空', trigger: 'blur' },
                    { min: 6, max: 50, message: '长度在 6 到 50 个字符', trigger: 'blur' }
                ],
                code: [{ required: true, message: '图片验证码不能为空', trigger: 'blur' }],
                mobileCode: [{ required: true, message: '短信验证码不能为空', trigger: 'blur' }],
                password: [
                    { required: true, message: '密码不能为空', trigger: 'blur' },
                    { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, message: '确认密码不能为空', trigger: 'blur' },
                    { validator: this.validateConfirmPassword, trigger: 'blur' }
                ]
            },
            projectVal: 'tpa',
            projectOptions: [
                {
                    label: '京东',
                    value: 'tpa'
                },
                {
                    label: '美团',
                    value: 'jiaanan'
                },
                {
                    label: '环球【UBI】',
                    value: 'ubi1'
                },
                {
                    label: '太保【UBI】',
                    value: 'ubi2'
                },
                {
                    label: '运营平台',
                    value: 'operate'
                }
            ]
        };
    },
    watch: {
        $route: {
            handler: function (route) {
                this.redirect = route.query && route.query.redirect;
            },
            immediate: true
        }
    },
    mounted() {
        this.getCaptcha();
        this.getRestCaptcha();
        // this.projectChange(1);
        if (localStorage.getItem('mark')) {
            this.projectVal = localStorage.getItem('mark');
            this.projectChange(localStorage.getItem('mark'));
        } else {
            this.projectChange('tpa');
            localStorage.setItem('mark', 'tpa');
        }

        if (this.$router.path != '/') {
            this.getCaptcha();
        }
    },
    methods: {
        // 获取图形验证码
        getCaptcha() {
            this.instance
                .get('/upms/api/captcha/generate', {})
                .then((res) => {
                    var data = res.data;
                    if (data.code === 200) {
                        this.qrcodeSrc = data.data;
                    }
                })
                .catch((res) => {});
        },

        getRestCaptcha() {
            this.instance
                .get('/upms/api/captcha/generate', {})
                .then((res) => {
                    var data = res.data;
                    if (data.code === 200) {
                        this.resetPasswordForm.captcha = data.data;
                    }
                })
                .catch((res) => {});
        },

        refreshRestCaptcha() {
            this.resetPasswordForm.captcha = '';
            this.getRestCaptcha();
        },

        resetPasswordDialogOpen() {
            this.resetPasswordFormClear();
            this.dialogVisible = true;
            this.resetPasswordForm.captcha = '';
            this.getRestCaptcha();
        },
        update() {
            location.reload();
        },
        cancelResetPwd() {
            // this.resetPasswordFormClear()
            this.dialogVisible = false;
            this.resetPasswordForm = {
                username: '',
                code: '',
                mobileCode: '',
                password: '',
                confirmPassword: '',
                uuid: '',
                captcha: ''
            };
        },
        resetPasswordFormClear() {
            this.resetPasswordForm = JSON.parse(JSON.stringify(this.resetPasswordForm));
        },

        refreshCode() {
            this.qrcodeSrc = '';
            this.getCaptcha();
        },
        //点击提交按钮的方法
        handleLogin() {
            var _this = this;
            if (!_this.form.username) {
                _this.$message.error('抱歉,请输入用户名!');
                return false;
            }
            if (!_this.form.password) {
                _this.$message.error('抱歉,请输入密码!');
                return false;
            }
            if (!_this.form.code) {
                _this.$message.error('抱歉,请输入验证码!');
                return false;
            }
            this.form.uuid = this.qrcodeSrc.uuid;
            this.isDisabled = true;
            this.instance
                .post('/upms/api/user/login', this.form)
                .then((res) => {
                    var data = res.data;
                    this.isDisabled = false;
                    if (data.code === 200) {
                        setTimeToken(data.data.tokenVo);
                        this.userMenuTree();
                        localStorage.setItem('AUTH_TOKEN', data.data.accessToken);
                        localStorage.setItem('username', data.data.nickName);
                        localStorage.setItem('userInfo', JSON.stringify(data.data));
                        let _path = '/system/userManage';
                        this.$router.push({ path: _path });
                    } else {
                        this.refreshCode();
                        this.$message.error(data.message);
                    }
                })
                .catch((res) => {
                    this.isDisabled = false;
                });
        },
        userMenuTree() {
            this.instance
                .get('/upms/api/menu/getMenuTree', this.form)
                .then((res) => {
                    localStorage.setItem('upmsMenu', JSON.stringify(res.data.data));
                })
                .catch((res) => {
                    console.log(res);
                });
        },

        getSmsCode() {
            if (this.resetPasswordForm.code === '') {
                this.$message.error('请输入图片验证码');
                return;
            }
            this.countdown = 60;
            setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    clearInterval(this.timer);
                    this.timer = null;
                }
            }, 1000);
            this.resetPasswordForm.uuid = this.resetPasswordForm.captcha.uuid;
            let param = JSON.parse(JSON.stringify(this.resetPasswordForm));
            this.instance
                .post('/upms/api/user/resetPasswordSms', param)
                .then((res) => {
                    let data = res.data;
                    if (data.code === 200) {
                        this.$message.info('发送短信验证码成功');
                    } else {
                        this.$message.error(data.message);
                    }
                })
                .cache((res) => {
                    console.log(res);
                    this.$message.error('发送短信验证码失败! 稍后重试');
                });
        },
        validateConfirmPassword(rule, value, callback) {
            if (value === '') {
                callback(new Error('确认密码不能为空'));
            } else if (value !== this.resetPasswordForm.password) {
                callback(new Error('两次输入密码不一致'));
            } else {
                callback();
            }
        },
        resetPassword() {
            this.$refs.resetPasswordForm.validate((vaild) => {
                if (vaild) {
                    this.instance
                        .post('/upms/api/user/resetPassword', this.resetPasswordForm)
                        .then((res) => {
                            let data = res.data;
                            if (data.code === 200) {
                                this.dialogVisible = false;
                                this.$message.success('重置密码成功');
                            } else {
                                this.$message.error(data.message);
                            }
                        })
                        .catch((res) => {
                            console.log(res);
                            this.$message.error('重置密码失败! 稍后重试');
                        });
                }
            });
        },
        projectChange(val) {
            switch (val) {
                case 'tpa':
                    localStorage.setItem('X-From-Business-Line', 'tpa');
                    localStorage.setItem('X-From-Tenant', '9999');
                    break;
                case 'jiaanan':
                    localStorage.setItem('X-From-Business-Line', 'jiaanan');
                    localStorage.setItem('X-From-Tenant', '11300');
                    break;
                case 'ubi1':
                    localStorage.setItem('X-From-Business-Line', 'ubi');
                    localStorage.setItem('X-From-Tenant', '10004');
                    break;
                case 'ubi2':
                    localStorage.setItem('X-From-Business-Line', 'ubi');
                    localStorage.setItem('X-From-Tenant', '10049');
                    break;
                case 'operate':
                    localStorage.setItem('X-From-Business-Line', 'operate');
                    localStorage.setItem('X-From-Tenant', '9527');
                    break;

                default:
                    break;
            }

            localStorage.setItem('mark', val);

            let baseUrlObj = {
                ['http:']: {
                    jiaanan: 'http://jiaanantest.platform.sigreal.cn/',
                    ubi1: 'http://ubiallinone-test.sigreal.cn/',
                    ubi2: 'http://ubiallinone-test.sigreal.cn/',
                    tpa: 'http://cargo-tpa.test.sigreal.cn/',
                    operate: 'http://operate-platform-test.sigreal.com.cn/'
                },
                ['https:']: {
                    jiaanan: 'https://jiaanan.platform.sigreal.cn/',
                    ubi1: 'https://evcard.sigreal.cn/',
                    ubi2: 'https://cpicfleet.sigreal.cn/',
                    tpa: 'https://jd-tpa.sigreal.cn/',
                    operate: 'https://operate-platform.sigreal.com.cn/'
                }
            };

            let baseUrl = baseUrlObj[location.protocol][localStorage.getItem('mark')] + '/manager';
            localStorage.setItem('origin', baseUrl);
        }
    },
    beforeDestroy() {
        // 组件销毁时清除定时器
        clearInterval(this.timer);
        this.timer = null;
    }
};
</script>
<style scoped>
.login_box .submit_btn {
    width: 100%;
    background: #22bdbd;
    border-color: #22bdbd;
    color: #fff;
}
.resetPassBtn {
    color: #409eff;
    cursor: pointer;
}

.login_box .el-button:focus,
.login_box .el-button:hover,
.code_btn:hover {
    background: #81eff0;
    border-color: #81eff0;
    color: #4c6161;
}

.verify-box {
    margin-left: 0.2rem;
    width: 86px;
}

.code_btn {
    width: 125px;
    margin-left: 15px;
    background: #22bdbd;
    color: #fff;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    border: none;
}

.code_btn.active {
    color: #aaa;
    background: #eeeeee;
}

.qrcode_input {
    width: 190px;
}

.qrcode /deep/ .el-form-item__content {
    display: flex;
    width: 100%;
}

.wrap {
    height: 100%;
    width: 100%;
    position: relative;
    background-image: url(/images/login_bg.jpg);
    background-repeat: no-repeat;
    background-color: #fff;
    background-size: cover;
    background-position: center;
}

.version {
    position: absolute;
    bottom: 0.5rem;
    right: 20%;
    z-index: 50;
    color: #858688;
}

.login_box {
    /* width:4.2rem;
     height:5.9rem; */
    width: 350px;
    /* height:320px; */
    position: absolute;
    top: 50%;
    right: 12%;
    transform: translate(-12%, -50%);
    z-index: 50;
    background: url(/images/login_form.png) no-repeat;
    background-size: 100% 100%;
    border-radius: 0.1rem;
    padding: 30px;
    /* color: #fff; */
}

.login_box .el-form-item__label {
    color: #fff !important;
}

.login_box .el-input__inner {
    background-color: rgba(255, 255, 255, 0.1);
    /* color: #fff; */
}

.login_title {
    font-size: 0.3rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #fff;
    margin-bottom: 40px;
    text-align: center;
}

.login_form {
    width: 100%;
    margin: 0 auto 0;
}

.login_form .el-input__inner {
    color: #cfdde5;
}

.login_btn button {
    border: none;
    background: #003b8f;
}

.login_btn button:hover {
    background: #01265a;
}

.user,
.password {
    width: 100%;
    /* height:0.48rem; */
    display: flex;
    align-items: center;
    flex-grow: 1;
    border-bottom: 1px solid #dfe5ec;
    padding: 0 0.16rem;
}

.password {
    justify-content: space-between;
}

.user span,
.password span {
    width: 0.14rem;
}

.password_box {
    display: flex;
    align-items: center;
}

.isshowpass {
    cursor: pointer;
    width: 0.22rem;
}

.login_btn {
    margin-top: 30px;
}

.login_btn button {
    width: 100%;
}
</style>